import type { URLString } from "@pdfking/structs"

import { SplitPath } from "../../internal/SplitPath"

/** The url an entry answers to outside the store holding it.
 *
 * A store is a name and a path inside it, which is what an authority and a
 * path already are — so a url here is not a location to fetch but the store
 * said in full: whoever holds the same platform can rebuild the store from the
 * authority and ask it for the path. Nothing is looked up to build one, so an
 * entry has a url whether or not anything is stored at it.
 *
 * The authority carries whatever it takes to name the store again, credentials
 * included — a grant needs the database it was filed in as well as the name it
 * was filed under, and `user@host` is where a url puts the pair. `file:` is
 * the exception the other way: a machine path is already absolute, so there is
 * no store to name and the authority is empty.
 *
 * Segments are encoded one at a time so a path keeps its shape: a space or a
 * `#` in a file name is part of the name, and `/` between two of them is not.
 * Built through URL rather than concatenated, so a malformed authority fails
 * here rather than at whatever tries to read it. */
export const StorageUrl = (protocol: string, authority: string, key: string): URLString =>
  new URL(`${protocol}//${authority}/${SplitPath(key).map(encodeURIComponent).join("/")}`)
    .href as URLString
